const routes = {
  shifts: 'Horário de trabalho',
  passengers: 'Funcionários'
};

export default routes;
